<template>
  <span v-if="displayLabel" class="exam-badge" :class="tierClass" :title="titleText">{{ displayLabel }}</span>
</template>

<script>
import { badgeTierClass, badgeTierLabel } from '@/utils/examBadge'

export default {
  name: 'ExamBadgeTag',
  props: {
    tier: { type: String, default: '' },
    label: { type: String, default: '' },
    examName: { type: String, default: '' },
    scorePercent: { type: [Number, String], default: 0 }
  },
  computed: {
    tierClass() {
      return badgeTierClass(this.tier)
    },
    displayLabel() {
      return this.label || badgeTierLabel(this.tier)
    },
    titleText() {
      const parts = []
      if (this.examName) parts.push(this.examName)
      if (this.displayLabel) parts.push(this.displayLabel)
      if (this.scorePercent) parts.push(`得分率 ${this.scorePercent}%`)
      return parts.join(' · ')
    }
  }
}
</script>

<style scoped>
.exam-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}
.exam-badge--gold {
  background: linear-gradient(135deg, #fff3bf, #ffd666);
  color: #874d00;
  border: 1px solid #ffc53d;
}
.exam-badge--silver {
  background: linear-gradient(135deg, #f5f5f5, #d9d9d9);
  color: #434343;
  border: 1px solid #bfbfbf;
}
.exam-badge--bronze {
  background: linear-gradient(135deg, #ffe7ba, #ffa940);
  color: #873800;
  border: 1px solid #ff9c6e;
}
.exam-badge--default {
  background: #f0f2f5;
  color: #606266;
}
</style>
